import {createSlice, PayloadAction} from "@reduxjs/toolkit";

export interface HiddenItem {
  id: number;
  type: "movie" | "tv";
}

interface HiddenState {
  items: HiddenItem[];
}

const initialState: HiddenState = {items: []};

const hiddenSlice = createSlice({
  name: "hidden",
  initialState,
  reducers: {
    hideItem(state, action: PayloadAction<HiddenItem>) {
      if (!state.items.find((i) => i.id === action.payload.id && i.type === action.payload.type)) {
        state.items.push(action.payload);
      }
    },
    unhideItem(state, action: PayloadAction<{id: number; type: "movie" | "tv"}>) {
      state.items = state.items.filter(
        (i) => !(i.id === action.payload.id && i.type === action.payload.type)
      );
    },
    clearHidden(state) {
      state.items = [];
    },
  },
});

export const {hideItem, unhideItem, clearHidden} = hiddenSlice.actions;
export default hiddenSlice.reducer;
